import { forwardRef, InputHTMLAttributes } from 'react'
import { motion } from 'framer-motion'

// Styles
import './input.scss'

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  errorMessage?: string | null
}

const animations = {
  initial: { opacity: 0, y: 0 },
  animate: { opacity: 1, y: -10 },
  exit: { opacity: 0, y: 0 },
}

type Ref = HTMLInputElement

export const Input = forwardRef<Ref, InputProps>((props, ref) => {
  const { errorMessage, ...inputProps } = props
  return (
    <div className="input-container">
      <input ref={ref} className={`input-container__input ${errorMessage && 'error'}`} {...inputProps} />
      {errorMessage && (
        <motion.p
          variants={animations}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={{ duration: 0.4 }}
          style={{ width: '100%' }}
          className="input-container__error-message"
        >
          {errorMessage}
        </motion.p>
      )}
    </div>
  )
})
